var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full mx-auto text-center",attrs:{"role":"status"}},[_c('svg',{staticClass:"spinner"},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"18"}})]),_c('p',{staticClass:" text-center sr-only"},[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }